/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export enum SearchSortField {
  Cost = "COST",
  Forecast = "FORECAST",
  Nid = "NID",
  ProviderId = "PROVIDER_ID",
  Region = "REGION",
  SavingsAmount = "SAVINGS_AMOUNT",
  Type = "TYPE",
}

export const ESTATE_SORT_OPTIONS = [
  {
    value: SearchSortField.Cost,
    label: "Monthly Cost",
  },
  {
    value: SearchSortField.Forecast,
    label: "Monthly Forecast",
  },
  {
    value: SearchSortField.SavingsAmount,
    label: "Potential Savings",
  },
  {
    value: SearchSortField.Type,
    label: "Resource Types",
  },
  {
    value: SearchSortField.Region,
    label: "Region",
  },
];
